import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MainService } from 'BaseServices/main-service';
import { UserService } from 'BaseServices/user-service';
import {
  ClientSummaryDTO,
  FeatureOptionSummaryDTO,
  FeatureDetailDTO,
  FeatureSummaryDTO,
  PlantSummaryDTO,
} from 'projects/Assets/src/assets-base/dataTypes';
import {
  dialogData,
  genericDialogComponent,
} from 'projects/Assets/src/assets-base/Dialogs/genericDialog';
import { dialogInputTitleComponent } from 'src/app/elements/dialog-input-title.component';
import { SaveButtonComponent } from 'src/app/buttons/save-button/save-button.component';
import { DeleteButtonComponent } from 'src/app/buttons/delete-button/delete-button.component';

@Component({
  selector: 'app-feature-dialog',
  imports: [
    dialogInputTitleComponent,
    FormsModule,
    SaveButtonComponent,
    DeleteButtonComponent,
  ],
  templateUrl: './feature-dialog.component.html',
  styleUrls: [
    './feature-dialog.component.css',
    '../../../../../../src/app/general-styles/dialogs.css',
  ],
})
export class FeatureDialogComponent
  extends genericDialogComponent
  implements OnInit
{
  readonly data = inject<dialogData<FeatureDetailDTO[]>>(MAT_DIALOG_DATA);
  @Input() featureRequest!: FeatureDetailDTO;

  currentUser = this.userService.currentUser;

  clients: ClientSummaryDTO[] = [];
  plants: PlantSummaryDTO[] = [];
  featureOptions: FeatureOptionSummaryDTO[] = [];

  get shownPlants() {
    return this.plants.filter((p) => {
      if (!this.featureRequest.clientId || this.featureRequest.clientId == 0) return true;
      const client = this.clients.find((c) => c.id === this.featureRequest.clientId);
      if (!client) return false;
      return p.clientName === client.name;
    });
  }
  clientCascade(clientId: number) {
    this.featureRequest.clientId = clientId;
    this.featureRequest.plantId = null;
  }

  constructor(
    public override dialogRef: MatDialogRef<FeatureDialogComponent>,
    public mainService: MainService,
    public userService: UserService
  ) {
    super(dialogRef);
    this.featureRequest = this.data.data[0];
    if (this.featureRequest.plantId == undefined)
      this.featureRequest.plantId = null;
  }

  ngOnInit(): void {
    this.mainService.getAll<ClientSummaryDTO>('Client').subscribe((result) => {
      this.clients = result;
    });

    this.mainService.getAll<PlantSummaryDTO>('Plant').subscribe((result) => {
      this.plants = result;
    });
    this.mainService
      .getAll<FeatureOptionSummaryDTO>('FeatureOption')
      .subscribe((result) => {
        this.featureOptions = result;
      });
  }
  saveChanges() {
    if (this.featureRequest.id == 0) {
      this.mainService
        .add<FeatureDetailDTO, FeatureSummaryDTO>(
          'Feature',
          this.featureRequest
        )
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    } else {
      this.mainService
        .update<FeatureDetailDTO, FeatureSummaryDTO>(
          'Feature',
          this.featureRequest
        )
        .subscribe((result) => {
          this.dialogRef.close(true);
        });
    }
  }

  deleteEntry() {
    if (!confirm("Er du sikker på at du vil slette komponentet?'")) {
      return;
    }
    this.mainService
      .delete('Feature', this.featureRequest.id)
      .subscribe((result) => {
        this.dialogRef.close(true);
      });
  }
}
